import { createFileRoute } from "@tanstack/react-router";
import { PackAdminEditPage } from "@client/components/settings/industry-pack/pack-admin-edit-page";

export const Route = createFileRoute("/_app/settings/industry-packs/$key")({
  component: PackAdminEditPage,
});
